module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/food/orange-42a821e3f6917aa5ddb0fc1cbfd07f1f.svg";